import { BrowserRouter, Routes, Route } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';
import i18n from './i18n';
import { I18nextProvider } from 'react-i18next';
import { useState } from 'react';

import { GameSettingsContext, GameSocketContext } from './modules/socketContexts';
import { getNoun } from "./modules/util";
import { getNativeProfile } from "./modules/nativeBridge";

import './App.scss';
import MainPage from './content/MainPage';
import BelotePage from './content/BelotePage';

const App = () => {
  const [nativeProfile] = useState(() => getNativeProfile());
  const [gameClientID] = useState(nativeProfile.userId || uuidv4());

  const [playerName, setPlayerName] = useState(
    nativeProfile.playerName || localStorage.getItem('playerName') || getNoun()
  );
  const updatePlayerName = (name) => {
    localStorage.setItem('playerName', name);
    localStorage.setItem('batak_playerName', name);
    setPlayerName(name);
  };

  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter>
        <Routes>
          <Route path='/game/:roomId' element={
            <GameSocketContext.Provider value={[gameClientID]}>
              <GameSettingsContext.Provider value={[playerName, updatePlayerName, nativeProfile]}>
                <BelotePage />
              </GameSettingsContext.Provider>
            </GameSocketContext.Provider>
          } />
          <Route path='/' element={
            <GameSettingsContext.Provider value={[playerName, updatePlayerName, nativeProfile]}>
              <MainPage />
            </GameSettingsContext.Provider>
          } />
        </Routes>
      </BrowserRouter>
    </I18nextProvider>
  );
};

export default App;
